export const INBOUND_EACH_MAX_QUANTITY = 36;

export function inboundEachQuantityError(quantity: number): string | null {
  const normalized = Math.trunc(quantity);
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return "Each quantity must be a positive integer.";
  }
  if (normalized > INBOUND_EACH_MAX_QUANTITY) {
    return "Each containers allow at most " + String(INBOUND_EACH_MAX_QUANTITY) + " pieces per seal.";
  }
  return null;
}